module.exports = __webpack_public_path__ + "img/GENERAL-XL7-2021-1.97599f1a.jpg";